export enum StatusTypes  {
  Awaiting = "Awaiting Delivery",
  Complete = "Complete Checking",
  Canceled = "Canceled",
}

export const StatusItems = [
  {
    label: StatusTypes.Awaiting,
    key: StatusTypes.Awaiting,
  },
  {
    label: StatusTypes.Complete,
    key: StatusTypes.Complete,
  },
  {
    label: StatusTypes.Canceled,
    key: StatusTypes.Canceled,
  },
];
